import { axiosInstance as axios } from "../../../service/axiosManager"

const WORKSPACE_API_URL = process.env.REACT_APP_HOST_API + "/workspace-messages"

export const AI_AGENT_ID = -4

export const getMessagesBetweenUserAndAI = async (userId, sessionId) => {
  if (!userId || !sessionId) return []
  try {
    const response = await axios.get(`${WORKSPACE_API_URL}/${sessionId}/${userId}`)
    return response.data.messages || []
  } catch (error) {
    console.error("Error fetching workspace chat history:", error)
    return []
  }
}

// learnMoreConcept: the concept id when the student sent this with the offloading strip's
// "Learn more" (the backend records it as that, not as an exchange to analyze).
export const saveMessage = async (content, senderId, recipientId, sessionId, codeSnapshot = null, { learnMoreConcept } = {}) => {
  if (!content || !sessionId) return null
  const payload = {
    chat: {
      session_id: sessionId,
      sender_id: senderId,
      recipient_id: recipientId,
      content: content,
      code_context: codeSnapshot,
      ...(learnMoreConcept ? { learn_more_concept: learnMoreConcept } : {}),
    }
  }
  try {
    const response = await axios.post(WORKSPACE_API_URL, payload)
    return response.data.message
  } catch (error) {
    console.error("Error saving workspace message:", error)
    return null
  }
}

export const updateMessageAssessment = async (messageId, assessmentData) => {
  try {
    const response = await axios.put(`${WORKSPACE_API_URL}/${messageId}/assessment`, assessmentData)
    return response.data
  } catch (error) {
    console.error("Error updating message assessment:", error)
    return null
  }
}

export const batchUpdateAssessments = async (updates) => {
  try {
    const response = await axios.post(`${WORKSPACE_API_URL}/assessments/batch`, { updates })
    return response.data
  } catch (error) {
    console.error("Error batch updating assessments:", error)
    return null
  }
}

export const getMessagesBySession = async (sessionId) => {
  try {
    const response = await axios.get(`${WORKSPACE_API_URL}/session/${sessionId}`)
    return response.data.messages || []
  } catch (error) {
    console.error("Error fetching session messages:", error)
    return []
  }
}